import React from 'react';

const EmptyState = ({ title = 'No data founded' }) => {
	return (
		<div className="trending-empty-section d-flex flex-column justify-content-center align-items-center">
			<p className="regular-12 gray_dark_02 text-center">{title}</p>
		</div>
	);
};

export default EmptyState;
